import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../../components/styles/AdminSidebar.css';

const AdminSidebar = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1635);
    const [isOpen, setIsOpen] = useState(window.innerWidth >= 1635);

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth < 1635;
            setIsMobile(mobile);
            setIsOpen(!mobile); // mobile이면 닫고, 아니면 열기
        };
        window.addEventListener('resize', handleResize);

        // 컴포넌트 마운트 시 한 번 체크
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleSidebar = () => setIsOpen(prev => !prev);

    return (
        <>
            {isMobile && (
                <button className="sidebar-toggle" onClick={toggleSidebar}>
                    ☰
                </button>
            )}
            <div className={`admin-sidebar ${isOpen ? 'open' : 'closed'}`}>
                <h2>관리자 메뉴</h2>
                <ul>
                    <li><Link to="/admin">구독 생성</Link></li>
                    <li><Link to="/admin/orders">주문 관리</Link></li>
                    <li><Link to="/admin/users">사용자 관리</Link></li>
                    <li><Link to="/admin/products">상품 관리</Link></li>
                    <li><Link to="/admin/coupons">쿠폰 관리</Link></li>
                    <li><Link to="/admin/settings">웹 사이트 설정</Link></li>
                    <li><Link to="/">메인 페이지</Link></li>
                </ul>
            </div>
        </>
    );
};

export default AdminSidebar;
